import React from 'react';
import { string } from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { BQLink } from '../../atoms/bqlink';
import get from 'lodash/get';
import Icon from '@mdi/react';
import { mdiFormatListBulleted, mdiTelevisionClassic } from '@mdi/js';
import './live-tv-widget.m.css';
import { useInView } from '../../../helpers/custom-hooks';
import { loadMoreInteraction, watchLiveInteraction } from '../../../helpers/datalayer-utils';
import LivetvPlayer from '../livetv-player';

const LiveTVWidget = ({ liveStreamUrl, sectionName = 'live-tv-widget' }) => {
  const [ref, inView] = useInView();
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  return (
    <div styleName="single-video-widget sv-video-player" ref={ref}>
      <div onClick={() => watchLiveInteraction(userData, pageType, sectionName)}>
        <BQLink href={`/live-tv?src=livetv_hp`}>
          <div styleName="sv-section-head">
            <div styleName="live-title-wrap">
              <div styleName="live-icon">
                <Icon path={mdiTelevisionClassic} size={1} color="white" />
              </div>
              <span styleName="left-title">LIVE TV</span>
            </div>
          </div>
        </BQLink>
      </div>

      <div styleName="sv-player-container">
        <div styleName="player-wrapper ">
          {inView && (
            <LivetvPlayer styleName="react-player" />
          )}
        </div>
        <div
          styleName="sv-bottom"
          onClick={() => loadMoreInteraction('More Videos', userData, pageType, 'LIVE TV')}
        >
          <BQLink href={`/videos?src=livetv_hp`} styleName="sv-bottom-text">
            <Icon path={mdiFormatListBulleted} size={1} color="white" />
            <span styleName="sv-bottom-title">More Videos</span>
          </BQLink>
        </div>
      </div>
    </div>
  );
};

LiveTVWidget.propTypes = {
  liveStreamUrl: string,
};

const mapStateToProps = (state) => {
  return {
    liveStreamUrl: get(
      state,
      ['qt', 'config', 'publisher', 'live_stream_url'],
      ['https://dai.google.com/linear/hls/event/QuU6z3GSTDaXuLL9Hs5A5Q/master.m3u8'],
    ),
  };
};
export default connect(mapStateToProps, null)(LiveTVWidget);
